import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PageContent from "@/lib/components/layout/page/PageContent.vue";
import {PropType} from "vue";
import {AspectRatio} from "@/lib/components/flexible/enum/AspectRatio";
import {PageContentLayoutPositioning} from "@/lib/components/layout/page/enum/PageContentLayoutPositioning";
import {PageContentLayoutSpaceTaken} from "@/lib/components/layout/page/enum/PageContentLayoutSpaceTaken";


export default /*#__PURE__*/_defineComponent({
  name: 'AppPage',
  props: {
  aspectRatio: String as PropType<AspectRatio>,
  pageContentLayoutPositioning: String as PropType<PageContentLayoutPositioning>,
  pageContentLayoutSpaceTaken: String as PropType<PageContentLayoutSpaceTaken>,
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageContent, {
    "aspect-ratio": __props.aspectRatio,
    "page-content-layout-positioning": __props.pageContentLayoutPositioning,
    "page-content-layout-space-taken": __props.pageContentLayoutSpaceTaken
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["aspect-ratio", "page-content-layout-positioning", "page-content-layout-space-taken"]))
}
}

})